<template>
  <v-btn
    @click.native="redirect()"
    :class="buttonColor"
    class="custom-buttons"
    :disabled="readonly"
  >
    <span style="white-space: normal;" :class="buttonText + '--text ' + sizeText">{{ title }}</span>
    <Icon
      class="btn-icon"
      v-if="icon != null"
      :type="icon"
      :theme="theme"
      :style="'color: ' + buttonIcon"
      style="fontSize:19px"
    />
  </v-btn>
</template>

<script>
import { Icon } from "ant-design-vue";

export default {
  name: "Button",
  components: { Icon },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    sizeText: {
      type: String,
      default: "large_text"
    },
    color: {
      type: String,
      default: "primary"
    },
    title: {
      type: String,
      default: "no title"
    },
    to: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      default: "outlined"
    }
  },
  computed: {
    buttonColor() {
      return this.color == "primary" ? "blue_1" : "greekblue_1";
    },
    buttonText() {
      return this.color == "primary" ? "blue_10" : "greekblue_10";
    },
    buttonIcon() {
      return this.color == "primary"
        ? this.$vuetify.theme.themes.light.green_10
        : this.$vuetify.theme.themes.light.greekblue_10;
    }
  },
  methods: {
    doAction() {
      this.action();
    },
    redirect() {
      if (this.to) {
        this.$router.push(this.to);
      }
    }
  }
};
</script>

<style scoped>
.custom-buttons {
  height: 64px !important;
  padding: 16px 32px !important;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
}
</style>